import allCampaign from '@/assets/resources/dld/allCampaign';
export var buildState = function () { return ({
    campaignList: allCampaign,
}); };
export var getters = {
    allCampaigns: function (state) {
        return state.campaignList;
    },
};
export var mutations = {};
export var actions = {};
export default {
    namespaced: true,
    state: buildState(),
    actions: actions,
    mutations: mutations,
    getters: getters,
};
